export const WHATSAPP_NUMBER = '551151986901';

export const WHATSAPP_NUMBER_COPY = '1151986901';

export const WHATSAPP_NUMBER_FORMATTED = '(11) 5198-6901';

export const WHATSAPP_TEL_LINK = `tel:${WHATSAPP_NUMBER}`;

export const WHATSAPP_MESSAGE_PLANS =
	'Olá, tenho interesse nos planos da Plumaa.';

export const WHATSAPP_LINK_PLANS = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
	WHATSAPP_MESSAGE_PLANS,
)}`;

export const WHATSAPP_MESSAGE_NR1 =
	'Olá, gostaria de saber mais sobre a adequação à NR-1 e como a Plumaa pode ajudar minha empresa.';

export const WHATSAPP_LINK_NR1 = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
	WHATSAPP_MESSAGE_NR1,
)}`;

export const WHATSAPP_MESSAGE_CANCEL = 'Olá, gostaria de cancelar minha sessão';

export const WHATSAPP_MESSAGE_B2B =
	'Olá! Sou da área de RH/Gestão e quero entender como a Plumaa pode apoiar a saúde mental do meu time. Podemos conversar sobre uma proposta para a empresa?';

export const WHATSAPP_MESSAGE_B2B2C =
	'Olá! Sou colaborador(a) e gostaria de levar a Plumaa para a minha empresa. Como posso indicar para o RH?';

export const WHATSAPP_MESSAGE_B2C =
	'Olá! Tenho interesse em começar meu cuidado com a Plumaa e queria entender como funciona para pessoa física.';

export const WHATSAPP_MESSAGE_BENEFIT =
	'Olá, gostaria de ativar meu benefício corporativo.';

export const WHATSAPP_MESSAGE_P2P =
	'Olá! Sou psicólogo(a) e tenho interesse na Plumaa para psicólogos. Gostaria de saber mais.';

export const WHATSAPP_LINK_P2P = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
	WHATSAPP_MESSAGE_P2P,
)}`;

export const WHATSAPP_LINK_CANCEL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
	WHATSAPP_MESSAGE_CANCEL,
)}`;

export const WHATSAPP_LINK_BENEFIT = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
	WHATSAPP_MESSAGE_BENEFIT,
)}`;

/** Mensagem para links que antes iam ao formulário (Typeform) – encaminha para WhatsApp. */
export const WHATSAPP_MESSAGE_FORM =
	'Olá, gostaria de mais informações sobre a Plumaa.';

export const WHATSAPP_LINK_FORM = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
	WHATSAPP_MESSAGE_FORM,
)}`;

export const buildWhatsAppUrl = (message: string): string =>
	`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const buildPatientSessionReminderMessage = (
	patientName: string,
	sessionAccessUrl: string,
): string =>
	`Olá, ${patientName}! Lembrete da sua consulta na Plumaa. Acesse pelo link: ${sessionAccessUrl}`;

/** Dígitos com DDI 55 para links wa.me (celular/ fixo BR). */
export const normalizeWhatsAppPhoneNumber = (
	phone?: string | null,
): string | null => {
	if (!phone?.trim()) return null;

	const digits = phone.replace(/\D/g, '');
	if (!digits) return null;

	if (digits.startsWith('55') && digits.length >= 12) {
		return digits;
	}

	if (digits.length === 10 || digits.length === 11) {
		return `55${digits}`;
	}

	if (digits.length >= 12) {
		return digits;
	}

	return null;
};

export const buildWhatsAppPatientSessionReminderUrl = ({
	url,
	patientName,
	phone,
}: {
	url: string;
	patientName?: string | null;
	phone?: string | null;
}): string => {
	const name = patientName?.trim() || 'paciente';
	const message = buildPatientSessionReminderMessage(name, url);
	const encoded = encodeURIComponent(message);
	const whatsappPhone = normalizeWhatsAppPhoneNumber(phone);

	if (!whatsappPhone) {
		throw new Error(
			'Telefone do paciente é obrigatório para abrir o WhatsApp.',
		);
	}

	return `https://wa.me/${whatsappPhone}?text=${encoded}`;
};
